// extracted by mini-css-extract-plugin
export default {"surveyTitleText":"survey_surveyTitleText__L2bkR"};